"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserTracker = exports.Telemetry = void 0;
const Client_1 = require("./src/Client");
const Telemetry_1 = require("./src/telemetry/Telemetry");
exports.Telemetry = Telemetry_1.default;
const BrowserTracker_1 = require("./src/BrowserTracker");
exports.BrowserTracker = BrowserTracker_1.default;
exports.default = Client_1.default;
//# sourceMappingURL=index.js.map